var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-gray-0"},[_c('account-look-up'),_c('about'),_c('products'),_c('how-to-activate'),_c('webinar'),_c('government-statement'),_c('faq')],1)}
var staticRenderFns = []

export { render, staticRenderFns }